"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDate = void 0;
function validateDate(_a) {
    var value = _a.value;
    return {
        valid: (value instanceof Date && value.toString() !== "Invalid Date") ||
            (typeof value === "string" &&
                new Date(value).toString() !== "Invalid Date"),
    };
}
exports.validateDate = validateDate;
